/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.0.0
 */
import { memo } from 'react';

import type { IPageSubscriberMobileTranslation } from '@modules/internationalization/types';

import type { IExtFilterItem, IExtFilterItemValue, IExtFilterMetaItem } from '../../types/extFilterTypes';
import { ExtFilterConstructorContainerStyled } from '../styled/ExtFilterConstructorBlockStyled';
import { ExtFilterConstructUtils } from './ExtFilterConstructorBlockUitls';
import ExtFilterConstructorItem, { IFilterConstructorItemOptions } from './ExtFilterConstructorItem';

/**
 * @description Filter constructor props
 * @interface IFilterConstructorBlockProps
 * @property {ISubscriberExtFilter} extFilter - external filter data
 * @property {IExtFilterMetaItem[]} extFilterMeta - external filters meta props
 * @property {Function} onChange onChagne callback
 * @property {IPageSubscriberMobileTranslation} translation - locale
 * @property {boolean} highlightEmpty highlight empty fields flag
 */
export interface IFilterConstructorBlockProps {
    extFilterMeta: IExtFilterMetaItem[];
    highlightEmpty: boolean;
    items: IExtFilterItem[];
    onChange: (arg: IExtFilterItemValue) => void;
    translation: IPageSubscriberMobileTranslation['extFilter'];
}

const ExtFilterConstructorBlock = (props: IFilterConstructorBlockProps) => {
    const utils = new ExtFilterConstructUtils(props);
    const { items, highlightEmpty, onChange } = props;
    const length = items.length;
    const itemOptions: IFilterConstructorItemOptions[] = utils.getItemOptions(items);
    return (
        <ExtFilterConstructorContainerStyled data-name='ext-filter-constructor-container'>
            {
                items.map((item: IExtFilterItem, index: number) => (
                    <ExtFilterConstructorItem
                        highlightEmpty={highlightEmpty}
                        index={index}
                        item={item}
                        key={'filter-item-' + index}
                        lastIndex={index === length - 1}
                        options={itemOptions[index]}
                        onChange={onChange}
                    />),
                )
            }
        </ExtFilterConstructorContainerStyled>
    );
};

export default memo(ExtFilterConstructorBlock);
